// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Caml_option = require("rescript/lib/js/caml_option.js");
var NotificationCount = require("./NotificationCount.bs.js");
var JsxRuntime = require("react/jsx-runtime");

function AnimatedNotificationCount(props) {
  var count = props.count;
  var match = React.useState(function () {
        return false;
      });
  var setAnimate = match[1];
  var match$1 = React.useState(function () {
        return 0;
      });
  var setCycle = match$1[1];
  var prevRef = React.useRef(count);
  var timeoutRef = React.useRef(undefined);
  React.useEffect((function () {
          var prev = prevRef.current;
          if (count > prev) {
            var id = timeoutRef.current;
            if (id !== undefined) {
              clearTimeout(Caml_option.valFromOption(id));
            }
            setAnimate(function (param) {
                  return false;
                });
            requestAnimationFrame(function (param) {
                  setAnimate(function (param) {
                        return true;
                      });
                  setCycle(function (c) {
                        return c + 1 | 0;
                      });
                  var id = setTimeout((function () {
                          setAnimate(function (param) {
                                return false;
                              });
                        }), 2000);
                  timeoutRef.current = Caml_option.some(id);
                });
          }
          prevRef.current = count;
        }), [count]);
  React.useEffect((function () {
          return (function () {
                    var id = timeoutRef.current;
                    if (id !== undefined) {
                      clearTimeout(Caml_option.valFromOption(id));
                      return ;
                    }
                    
                  });
        }), []);
  return JsxRuntime.jsx(NotificationCount.make, {
              count: count,
              animate: match[0],
              isOpened: props.isOpened
            }, match$1[0].toString());
}

var make = AnimatedNotificationCount;

exports.make = make;
/* react Not a pure module */
